"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLookup = void 0;
class BaseLookup {
    constructor(id, value) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: id
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
        });
    }
    getId() {
        return this.id;
    }
    getValue() {
        return this.value;
    }
}
exports.BaseLookup = BaseLookup;
